<template>
  <div class="weekly-report">
    <h3 class="title text-gray-700 font-medium">Repeat on</h3>

    <div class="days">
      <day-selection
        v-for="repeat in repeatOn"
        :key="repeat.dayOfWeek.label"
        :title="repeat.dayOfWeek.label"
        :is-all-day="isAllDay"
        :repeat="repeat"
      ></day-selection>
    </div>
  </div>
</template>

<script>
import DaySelection from "./DaySelection";

export default {
  components: { DaySelection },
  props: ["isAllDay", "repeatOn"]
};
</script>

<style lang="scss" scoped></style>
